module.exports = __webpack_public_path__ + "static/slide14-1fafed5f4ade144135c2cbcf11412e50.jpg";